import React, { useEffect } from 'react';
import { useQuery, useQueryCache } from 'react-query';
import { api } from "../../../api";
import PropTypes from 'prop-types';
import moment from 'moment';

// Pendant de StoreStatusChangeLogs (Uber Eats) : les pauses et réouvertures
// faites depuis flow, avec leur auteur.
const DeliverooSiteStatusChangeLogs = ({ siteId, siteName, isOpen, setIsOpen }) => {
  const queryCache = useQueryCache();
  const { isError, data, error, refetch } = useQuery(
    ['deliverooSiteStatusChangeLogs', siteId],
    (_key, id) => api.listDeliverooSiteStatusChangeLogs(id),
    {
      retry: 0,
      enabled: isOpen,
    }
  );

  useEffect(() => {
    if (isOpen) {
      queryCache.invalidateQueries({ queryKey: ['deliverooSiteStatusChangeLogs', siteId] });
      refetch();
    }
  }, [isOpen]);

  return (
    <div className={`modal ${isOpen ? 'show' : ''}`} tabIndex="-1" style={{ display: isOpen ? 'block' : 'none' }}
      aria-hidden={!isOpen}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Changements de statut pour <b>{siteName}</b></h5>
            <button type="button" className="close" aria-label="Close" onClick={() => setIsOpen(false)}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {isError && (<span>{error.message}</span>)}
            {data && data.logs && data.logs.length === 0 && (
              <span>Aucun changement fait depuis flow.</span>
            )}
            {data && data.logs && data.logs.length > 0 && (
              <table className="table">
                <thead>
                  <tr className="thead-light">
                    <th scope="col">Nouv. statut</th>
                    <th scope="col">Action par</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data.logs.map(log => (
                    <tr key={JSON.stringify(log)}>
                      <td><b>{log.status === 'OPEN' ? 'OUVERT' : 'EN PAUSE'}</b></td>
                      <td>{log.done_by || '-'}</td>
                      <td>{moment(log.created_at).locale('fr').format('LLLL')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

DeliverooSiteStatusChangeLogs.propTypes = {
  siteId: PropTypes.number.isRequired,
  siteName: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

export default DeliverooSiteStatusChangeLogs;
